/**
 * About page copy. The position and pillars are the guidelines' own
 * (brand/GUIDELINES.md §1); sections I and III carry the owner's copy pass of
 * 2026-09-15. Public prose rules: closed em dashes, no Oxford comma.
 */

export const ABOUT_META = {
  title: 'About Melio · quiet stewardship of your health',
  description:
    'Melio is a boutique preventive practice. One expert team that brings testing, specialists, records and long-term planning together and follows them over time.',
} as const;

export const ABOUT_INTRO = {
  statement:
    'Melio is built around quiet stewardship. The trusted expert working behind the scenes, so that you can get on with living well.',
} as const;

export interface AboutSection {
  numeral: string;
  title: string;
  paragraphs: string[];
}

export const ABOUT_SECTIONS: AboutSection[] = [
  {
    numeral: 'I',
    title: 'Who we are',
    paragraphs: [
      'Melio is a boutique preventive practice. We bring every part of your health together under one expert team—testing and appointments, specialists, records and long-term planning—so that nothing gets lost to a busy life.',
      'Clinical rigour is not measured by the number of tests ordered. It comes from knowing what to investigate, interpreting findings in context and following them over time.',
    ],
  },
  {
    numeral: 'II',
    title: 'How we work',
    paragraphs: [
      'Stewardship. We create with care and longevity in mind; a plan should feel considered and enduring rather than driven by the latest test.',
      'Accountability. Every recommendation has a reason to exist, written down, so you can see what we are watching and why.',
      'Expertise. Authority comes from judgement, not from overstating it. Your clinician tells you what matters now and what can wait.',
      'Precision. Every detail is intentional—from the schedule of what to check to the words in your report.',
      'Warmth. Rigour is balanced with humanity. The people who hold your record know you by name.',
    ],
  },
  {
    numeral: 'III',
    title: 'The practice',
    paragraphs: [
      'Melio is based in the United Kingdom and led by a small clinical team: a named care clinician for each member, reviewed by a senior clinician, with a relationship manager who keeps everything moving between appointments.',
      "Melio Health Solutions Ltd is registered in England and Wales (company number 16497996) and with the Information Commissioner's Office (registration ZC153092).",
    ],
  },
];
